import { fetchQuery, graphql } from "relay-runtime"
import {
  betterDocRecommendedRecommendationsQuery,
  betterDocRecommendedRecommendationsQuery$data,
} from "@/modules/admin/better-doc/services/__generated__/betterDocRecommendedRecommendationsQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"
import { Country } from "@/types/__generated__/union-types"

const query = graphql`
  query betterDocRecommendedRecommendationsQuery($insuranceCountry: Country!) {
    de_betterDocRecommendedRecommendations(insuranceCountry: $insuranceCountry) {
      status
      httpStatusCode
      errorReason
      exchangeId
      recommendations {
        recommendationId
        state
        version
        partnerPatientId
        partnerSessionId
        localSessionId
        selectionType
        selectionId
        medics {
          selectionId
        }
        selectedMedic {
          name
        }
      }
    }
  }
`

export type BetterDocOpenRecommendationsResult =
  betterDocRecommendedRecommendationsQuery$data["de_betterDocRecommendedRecommendations"]

export type BetterDocOpenRecommendation = BetterDocOpenRecommendationsResult["recommendations"][number]

export const fetchBetterDocRecommendedRecommendations = (
  insuranceCountry: Country,
): Promise<BetterDocOpenRecommendationsResult> =>
  fetchQuery<betterDocRecommendedRecommendationsQuery>(
    RelayEnvironment,
    query,
    { insuranceCountry },
    { fetchPolicy: "network-only" },
  )
    .toPromise()
    .then((response) => {
      if (!response) {
        throw new Error("BetterDoc returned no response")
      }

      return response.de_betterDocRecommendedRecommendations
    })
